import { COMPANY, normalizePhoneForWa } from "@/mock";

export const Container = ({ className = "", children }) => (
  <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

export function setTitle(title) {
  if (typeof document !== "undefined") {
    document.title = `${title} | ${COMPANY.name}`;
  }
}

export function makeWhatsAppUrl(phone, text) {
  const n = normalizePhoneForWa(phone);
  const q = new URLSearchParams();
  if (text) q.set("text", text);
  return `https://wa.me/${n}?${q.toString()}`;
}

export function makeTelUrl(phone) {
  return `tel:${String(phone || "").replace(/\s/g, "")}`;
}

export function makeMailUrl(email) {
  return `mailto:${email}`;
}

export function saveLead(payload) {
  const key = "nwp_leads";
  const raw = localStorage.getItem(key);
  const arr = raw ? JSON.parse(raw) : [];
  arr.unshift({ id: crypto.randomUUID(), createdAt: new Date().toISOString(), ...payload });
  localStorage.setItem(key, JSON.stringify(arr.slice(0, 50)));
}
